(ns practitest.frontend.forms3.run
  (:require
    [clojure.string :as str]
    [practitest.frontend.common-entities.events :as common-events]
    [practitest.frontend.common-entities.metadata :as metadata]
    [practitest.frontend.common.format-utils :as fu]
    [practitest.frontend.common.i18n :refer [get-translation]]
    [practitest.frontend.common.mixpanel :as mixpanel]
    [practitest.frontend.common.permissions :as permissions]
    [practitest.frontend.common.re-frame :refer [partial-dispatch]]
    [practitest.frontend.components2.entity-form.forms :as forms]
    [practitest.frontend.components2.run-status :as run-status]
    [practitest.frontend.events :as events]
    [practitest.frontend.forms3.entity-form :as f3.entity-form]
    [practitest.frontend.forms3.entity-form.collab-ws :as collab-ws]
    [practitest.frontend.forms3.entity-form.forms :as f3.forms]
    [practitest.frontend.forms3.run.events :as run-events]
    [practitest.frontend.forms3.run.navigation :as run-navigation]
    [practitest.frontend.routing.backend-routes :as broutes]
    [practitest.frontend.subs :as subs]
    [re-frame.core :as re-frame]))

(def ^:private entity-type :run)
(def ^:private metadata (get metadata/entities-metadata entity-type))
(def ^:private form-id (get metadata :form-id))
(def ^:private edit-permission (get metadata :edit-permissions))

(defn- form-layout-run [entity-fields]
  (let [nil-or-unavailable? (fn [field]
                              (or (nil? field)
                                  (not (contains? entity-fields field))))
        initial-layout {:title {:fields [{:field :name}]}}
        existing-fields (set (f3.forms/flatten-layout initial-layout))
        to-remove? (fn [field]
                     (or (nil-or-unavailable? field)
                         (contains? existing-fields field)))
        filtered-entity-fields (f3.entity-form/filter-entity-fields entity-fields to-remove?)
        filtered-entity-fields-flat (vec (keys filtered-entity-fields))
        entity-sections @(re-frame/subscribe [::subs/entity-sections entity-type])
        update-main-sections (if (some? entity-sections)
                               #(f3.entity-form/update-layout % entity-sections filtered-entity-fields)
                               #(f3.entity-form/update-layout % (:general-info f3.entity-form/sections-keys) filtered-entity-fields-flat "general_info" entity-fields))
        layout (-> initial-layout (update-main-sections))]
    layout))

(defmethod f3.forms/build-entity-form-layout form-id
  [_ _ _ entity-fields _]
  (form-layout-run entity-fields))

(defn build-edit-controller []
  {:start (fn [params]
            (let [{:keys [run-id project-id]} (:path params)]
              (re-frame/dispatch [::forms/reset-form-state false entity-type form-id []])
              (re-frame/dispatch [::events/set-current-entity-type entity-type])
              (re-frame/dispatch [::subs/set-current-entity-id entity-type run-id])
              (let [fetch-options {:form-id     form-id
                                   :entity-type entity-type
                                   :entity-id   run-id
                                   :project-id  project-id
                                   :new?        false
                                   :got-entity-data [::run-events/got-run]}]
                (re-frame/dispatch [::f3.entity-form/fetch-fields fetch-options])
                (re-frame/dispatch [::f3.entity-form/fetch-entity fetch-options])
                (re-frame/dispatch [::collab-ws/subscribe-to-form-ws [(:plural-key metadata)]]))
              (re-frame/dispatch [::events/fetch-history])
              (re-frame/dispatch [::common-events/trigger-online-request])
              (mixpanel/track "Grid Actions" {"Action" "Edit Run"})))
   :stop (fn [_params]
           (re-frame/dispatch [::events/clear-current-entity entity-type])
           (re-frame/dispatch [::collab-ws/unsubscribe-form-ws [(:plural-key metadata)]])
           (re-frame/dispatch [::forms/reset-form-state false entity-type form-id []]))
   :identity :parameters})

(defn build-tabs []
  [(f3.entity-form/general-entity-tab)
   (f3.entity-form/history-tab)])

(defn- run-name-field [{:keys [base-entity]}]
  (let [run-name     (:name base-entity)
        created-at   (:created_at base-entity)
        status       (some-> (:status base-entity) str/upper-case)
        status-color (when status (run-status/get-status-color status))]
    [:div.g2-field-container.run-name-container
     [:span.visually-hidden {:id "name-lbl"} (get-translation "generic.fields.name" "Name")]
     [:div.input-with-message-container
      [:div.m-readonly-field
       run-name
       (when created-at
         [:span.run-name-creation-date
          (str "(" (get-translation "run.creation-date" "Creation Date") ": "
               (fu/formatted-date-time created-at) ")")])]
      (when (and status status-color)
        [:span.run-status-badge
         {:style {:background-color (str "color-mix(in srgb, " status-color " 15%, white)")
                  :color            status-color}}
         (run-status/get-status-label status)])]]))

(defn main [new?]
  (let [run @(re-frame/subscribe [::forms/base-entity entity-type])
        parent-instance @(re-frame/subscribe [::run-events/parent-instance])
        parent-testset @(re-frame/subscribe [::run-events/parent-testset])
        parent-test @(re-frame/subscribe [::run-events/parent-test])]
    [f3.entity-form/entity-form
     {:new?         new?
      :entity-type  entity-type
      :form-id      form-id
      :on-save      (partial-dispatch [::run-events/save-run (:id run)])
      :on-cancel    (partial-dispatch [::run-events/reset-run-form new?])
      :last-breadcrumb-fn
      (fn [_props]
        (if parent-test
          (str (get-translation "run.run-of-test" "Run of Test") " #" (:display_id parent-test))
          (get-translation "generic.loading" "Loading")))
      :entity-name-renderer
      (fn [_form-props]
        (let [pt @(re-frame/subscribe [::run-events/parent-test])]
          [:span.entity-name
           (if pt
             (str (get-translation "run.run-of-test" "Run of Test") " #" (:display_id pt))
             (get-translation "run.singular" "Run"))]))
      :header-name-fn run-name-field
      :breadcrumbs
      (when (and parent-testset parent-instance parent-test)
        [{:href     (broutes/get-url-view "suites#edit" {:id (:id parent-testset)})
          :label    (str (f3.forms/entity->display-name :testset)
                         " #" (:display_id parent-testset)
                         ": " (:name parent-testset))
          :on-click #(mixpanel/track "Run Form Actions" {"Action" "Breadcrumb Test Set Clicked"})}
         {:href     (broutes/get-url-view "instances#edit" {:id (:id parent-instance)})
          :label    (str (get-translation "test.instance-of-test" "Instance of Test") " #" (:display_id parent-test)
                         ": " (:name parent-test))
          :on-click #(mixpanel/track "Run Form Actions" {"Action" "Breadcrumb Instance Clicked"})}])
      :breadcrumbs-right          (fn [] [run-navigation/run-navigation (:id run)])
      :header-tabs                (build-tabs)
      :edit-permissions?          (permissions/has-permission? edit-permission)
      :customization-permissions? (permissions/has-permission? "customization")}]))
